// This file was automatically generated from print.patientFormReport.html.
// Please don't edit this file by hand.

goog.provide('el8.template.print.report.patientForm');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.report.patientForm.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<p class="patientName">Form: ', soy.$$escapeHtml(opt_data.formCollection.formName), '</p><br />');
  var topicList15924 = opt_data.formCollection.value.answers;
  var topicListLen15924 = topicList15924.length;
  for (var topicIndex15924 = 0; topicIndex15924 < topicListLen15924; topicIndex15924++) {
    var topicData15924 = topicList15924[topicIndex15924];
    el8.template.print.report.patientForm.topic({topic: topicData15924, reportCreateDate: opt_data.reportCreateDate}, output);
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.report.patientForm.topic = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8Bold">', soy.$$escapeHtml(opt_data.topic.label), '</div>');
  var questionList15933 = opt_data.topic.questions;
  var questionListLen15933 = questionList15933.length;
  for (var questionIndex15933 = 0; questionIndex15933 < questionListLen15933; questionIndex15933++) {
    var questionData15933 = questionList15933[questionIndex15933];
    el8.template.print.report.patientForm.question({topic: opt_data.topic, question: questionData15933, reportCreateDate: opt_data.reportCreateDate}, output);
  }
  output.append((opt_data.topic.totalScore != null) ? '<br /><div>Total score: ' + soy.$$escapeHtml(opt_data.topic.totalScore) + ' points</div>' : '', '<br /><br />');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.report.patientForm.question = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<br />', (opt_data.topic.displayPromptsInReport) ? '<p>' + soy.$$escapeHtml(opt_data.question.prompt) + '</p>' : '');
  var answerLineList15952 = opt_data.question.answerLines;
  var answerLineListLen15952 = answerLineList15952.length;
  for (var answerLineIndex15952 = 0; answerLineIndex15952 < answerLineListLen15952; answerLineIndex15952++) {
    var answerLineData15952 = answerLineList15952[answerLineIndex15952];
    el8.template.print.report.patientForm.answerLine({answerLine: answerLineData15952, questionInput: opt_data.question.input, reportCreateDate: opt_data.reportCreateDate}, output);
  }
  output.append((! opt_data.question.answerLines.length) ? '<p>– No response –</p>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.report.patientForm.answerLine = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<p>', (opt_data.answerLine.isFileUrl) ? '<img src="' + soy.$$escapeHtml(opt_data.answerLine.displayText) + '" alt="' + soy.$$escapeHtml(opt_data.questionInput.type) + '" width="300" />' : (opt_data.questionInput.type == 'radio_button_list' && opt_data.questionInput.name == 'signature_agreement') ? (opt_data.answerLine.displayText == 'YES') ? 'I agree (' + (soy.$$escapeHtml(opt_data.reportCreateDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.reportCreateDate)) : '') + ').' : 'I do not agree (' + (soy.$$escapeHtml(opt_data.reportCreateDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.reportCreateDate)) : '') + ').' : soy.$$escapeHtml(opt_data.answerLine.displayText), (opt_data.answerLine.score != null) ? '&nbsp;(' + soy.$$escapeHtml(opt_data.answerLine.score) + ' points)' : '', (opt_data.answerLine.metadata && opt_data.answerLine.metadata.medicationName) ? '&nbsp;(matched to: ' + soy.$$escapeHtml(opt_data.answerLine.metadata.medicationName) + ')' : '', '</p>');
  if (!opt_sb) return output.toString();
};
